import React from 'react';

import FilterSearch from '@components/uikit/FilterSearch/FilterSearch';
import Switch from '@components/uikit/Switch/Switch';
import TreeSelect from '@components/uikit/TreeSelect/TreeSelect';

import { getTreeSelectData } from '@helpers/getTreeSelectData';

import useTranslation from '@hooks/useTranslation';

import { useAssetTreeQuery } from '@services/useAssetTreeQuery';

import {
  selectManageTemplateFilterLocationValue,
  selectManageTemplateFilterSearchValue,
  selectManageTemplateFilterShowIncludedTemplateValue,
  useManageTemplateFilterActions,
} from '../../store/useManageTemplateFilterStore';
import style from './style.module.scss';

const FilterPanel = () => {
  const { t } = useTranslation();

  const {
    setManageTemplateFilterSearchValue,
    setManageTemplateFilterLocationValue,
    setManageTemplateFilterShowIncludedTemplateValue,
    setManageTemplateFilterSelectedRows,
  } = useManageTemplateFilterActions();

  const searchValue = selectManageTemplateFilterSearchValue();
  const locationValue = selectManageTemplateFilterLocationValue();
  const showIncludedTemplateValue = selectManageTemplateFilterShowIncludedTemplateValue();

  const { data: assetTreeData } = useAssetTreeQuery();

  return (
    <div className={style.filterPanel}>
      <div className={style.filter}>
        <div className={style.manageTemplateFilter}>
          <TreeSelect
            label={t('Location')}
            items={getTreeSelectData(assetTreeData?.facilities, t)}
            onChange={(value, node) => setManageTemplateFilterLocationValue({ id: value, name: node.name })}
            selectedName={locationValue.name}
            fieldNames={{
              title: 'name',
              key: 'id',
            }}
          />
          <Switch
            value={showIncludedTemplateValue}
            onChange={() => {
              setManageTemplateFilterSelectedRows(new Map());
              setManageTemplateFilterShowIncludedTemplateValue(!showIncludedTemplateValue);
            }}
            label={t('Show included equipment in the template')}
            type="woHelperText"
          />
        </div>
      </div>
      <div className={style.searchBlock}>
        <FilterSearch
          value={searchValue}
          variant={'header-search'}
          placeholder={t('Start to type...')}
          onChange={setManageTemplateFilterSearchValue}
        />
      </div>
    </div>
  );
};

export default FilterPanel;
